import styled from 'styled-components'

export const SpinnerWrapper = styled.div`
  position: absolute;
  left: 50%;
  top: 20%;
`
